<template>
  <div class="animated fadeIn authentication-bg">
    <div class="account-pages">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-5">
            <div class="card mt-4">
              <!-- Logo -->
              <div class="card-header pt-3 pb-3 text-center bg-primary">
                <span class="text-white font-weight-bold h2">Nipige</span>
              </div>
              <div class="card-body p-4">
                <div class="text-center w-75 m-auto">
                  <h4 class="text-dark-50 text-center mt-0 font-weight-bold">Sign In</h4>
                  <p class="text-muted mb-4">
                    Enter your email address and password to access
                  </p>
                </div>
                <div>
                  <eb-input
                    lable="Email address"
                    id="emailaddress"
                    placeholder="Enter your email"
                    v-model="userName"
                  ></eb-input>
                  <eb-input
                    class="mt-2"
                    lable="Password"
                    id="Password"
                    placeholder="Enter your password"
                    v-model="password"
                    type="password"
                  ></eb-input>
                  <div class="form-group mb-3 mt-3">
                    <eb-select
                      id="sl"
                      type="text"
                      v-model="role"
                      :options="selectOption"
                      placeholder="Select which way to login"
                    ></eb-select>
                  </div>
                  <div
                    class="form-group mb-3 mt-3"
                    v-if="role !== 'Admin' && role !== 'Tenant'"
                  >
                    <eb-select
                      id="tenant"
                      type="text"
                      v-model="selectedTenant"
                      label="name"
                      :options="tenantList"
                      placeholder="Select Tenant"
                    ></eb-select>
                  </div>
                  <div class="form-group mb-0 text-center">
                    <button
                      class="btn btn-primary btn-lg mr-2"
                      @click="login"
                      :disabled="
                        role === 'Partner'
                          ? !(selectedTenant && selectedTenant._id)
                          : false
                      "
                    >
                      {{ loading ? "" : "Login" }}
                      <v-progress-circular :size="20" indeterminate v-if="loading" />
                    </button>
                  </div>
                  <div class="text-center mt-2">
                    <router-link to="/recoverpw">
                      <a class="text-muted"> Forgot password? </a>
                    </router-link>
                  </div>
                </div>
              </div>
              <!-- end card-body -->
            </div>
            <!-- end card -->
            <!-- end row -->
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </div>
    <!-- end page -->
  </div>
</template>
<script>
import { login } from "../../services/auth";
import ebInput from "@/components/FormElements/Input.vue";
import ebSelect from "@/components/FormElements/Select.vue";
import "vue-select/dist/vue-select.css";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      userName: "",
      password: "",
      role: "",
      selectOption: [
        "Admin",
        "Tenant",
        "Seller",
        "State Operating Unit",
        "Sector Franchisee",
        "TSK",
      ],
      loading: false,
      selectedTenant: null,
    };
  },
  components: {
    ebInput,
    ebSelect,
  },
  methods: {
    ...mapActions({
      GetTenantList: "tenant/fetchTenantsListLite",
    }),
    validateEmail(email) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    isPermission(perm) {
      return perm && perm.name;
    },
    validatePhone(phone) {
      let re = /^\d{10}$/;
      return re.test(String(phone));
    },
    isEmailOrPhone() {
      let code = 0;
      if (this.validateEmail(this.userName)) {
        code = 1;
      }
      if (this.validatePhone(this.userName)) {
        code = -1;
      }
      return code;
    },
    async login() {
      if (this.role.length > 0) {
        if (this.role !== "Admin" && this.role !== "Tenant") {
          this.role = "Partner";
        }
        try {
          if (this.userName) {
            this.loading = true;
            let code = this.isEmailOrPhone();
            let opts = {
              password: this.password,
            };
            if (code === 1) {
              opts.email = this.userName;
            } else if (code == -1) {
              opts.phone = this.userName;
            } else {
              opts.userName = this.userName;
            }
            sessionStorage.setItem("userRole", this.role);
            if (this.role === "Partner") {
              sessionStorage.setItem("nipige:key", this.selectedTenant._id);
            }
            let response = await login(this.role, opts);
            // check for force password update for tenant or partner.
            if (
              this.role === "Partner" &&
              response.response.user.authentication.forceChangePass
            ) {
              sessionStorage.setItem(
                "nipige:forcechangepass",
                JSON.stringify({
                  type: "Partner",
                  token: response.response.token,
                })
              );
              this.$router.push("/changepassword");
              return false;
            }
            this.$store.dispatch("auth/setUserRole", this.role);
            const { user, token } = response.response;
            const { authorization, authentication, _id, address } = user;
            await this.$store.dispatch("permission/fetchPermissionsByUser", {
              token: token,
              data: authorization.roles,
            });
            const permissions = await this.$store.getters[
              "permission/GetUserPermissions"
            ];
            let permissionObj = {};
            for (let i = 0; i < permissions.length; i++) {
              if (this.isPermission(permissions[i].permission)) {
                permissionObj[permissions[i].permission.name] = 1;
              }
            }
            let userCatalog = [];
            // If logged in with Tenant
            if (this.role === "Tenant") {
              sessionStorage.setItem("userName", this.userName);
              this.$store.dispatch(
                "auth/setCatalog",
                response.response.user.agreement.businessSegmentInfo
              );
              userCatalog = response.response.user.agreement.businessSegmentInfo;
              if (userCatalog.length > 0) {
                this.$store.dispatch(
                  "tenant/setTenantCatalogAccess",
                  userCatalog[0]["categoryType"]
                );
              }
              permissionObj["TENANT_DASH"] = 1;
              permissionObj["ORG_HIERARCHY"] = 1;
              permissionObj["SERVICE_TICKET"] = 1;
              permissionObj["MANAGE_ORDERS"] = 1;
              permissionObj["PAYMENT_RECORD"] = 1;
              permissionObj["READ_FAQ"] = 1;
              permissionObj["CREATE_SETUP"] = 1;
              permissionObj["CREATE_COMMISSION_SETUP"] = 1;
              permissionObj["CREATE_ADVERTISEMENT"] = 1;
              permissionObj["CREATE_TAXCODE"] = 1;
              permissionObj["COMMISSION"] = 1;
              permissionObj["CREATE_SERVICEREQUEST_SETUP"] = 1;
              permissionObj["CREATE_FAQ_SETUP"] = 1;
              permissionObj["CREATE_COUPON"] = 1;
              permissionObj["CREATE_SUBSCRIPTION"] = 1;
              permissionObj["CREATE_ACCESS_RULE"] = 1;
              permissionObj["CREATE_DELIVERY_SETUP"] = 1;
              permissionObj["CREATE_TEMPLATE"] = 1;
            }
            // If logged in with Admin
            else if (this.role === "Admin") {
              this.$store.dispatch("auth/setCatalog", []);
              permissionObj["ADMIN_DASH"] = 1;
              permissionObj["SERVICE_REQUEST"] = 1;
              permissionObj["MANAGE_ORDERS"] = 1;
            }
            // If logged in with Partners
            else if (this.role === "Partner") {
              permissionObj["TENANT_DASH"] = 1;
              permissionObj["ORG_HIERARCHY"] = 1;
              permissionObj["SERVICE_TICKET"] = 1;
              permissionObj["MANAGE_ORDERS"] = 1;
              permissionObj["MANAGE_TEAM"] = 1;
              permissionObj["READ_FAQ"] = 1;
              permissionObj["CREATE_SETUP"] = 1;
              permissionObj["CREATE_DELIVERY_SETUP"] = 1;
              if (user.category !== "DISTRIBUTOR" && user.category !== "DEALER") {
                permissionObj["SUB_OFFICE_HIERARCHY"] = 1;
              }
              if (user.category !== "SELLER") {
                permissionObj["COMMISSION"] = 1;
              }
              if (user.category === "SELLER") {
                permissionObj["CREATE_SETUP"] = 1;
                permissionObj["CREATE_COUPON"] = 1;
              }
              if (user.category === "DISTRIBUTOR") {
                permissionObj["MANAGE_APPROVAL"] = 1;
                permissionObj["PAYMENT_RECORD"] = 1;
              }
              if (
                user.category === "SELLER" &&
                response.response.user.preferences.manageOwnCustomer
              ) {
                permissionObj["MANAGE_OWN_CUSTOMER"] = 1;
              }
              userCatalog = response.response.user.agreement.marketSegment;
              this.$store.dispatch(
                "auth/setCatalog",
                response.response.user.agreement.marketSegment
              );
            }
            const userObj = {
              ...authentication,
              _id,
              catalogInfo: userCatalog,
              permissions: permissionObj,
              token,
              role: this.role,
              userLogo: "img/avatars/6.jpg",
            };
            if (this.role === "Admin") {
              userObj.category = user.category;
              userObj.tenant = response.response.user.tenant;
            }
            this.loading = false;
            if (this.role === "Partner") {
              userObj.category = user.category;
              userObj.tenant = response.response.user.tenant;
              userObj.userLogo = response.response.user.organization.logo.url;
              if (response.response.user.parentPartner) {
                userObj.parentPartner = response.response.user.parentPartner;
              }
            }
            if (this.role === "Tenant") {
              userObj.category = user.category;
              userObj.userLogo = response.response.user.company.logo;
              userObj.enableManufacturer = user.preferences.enableManufacturer
                ? user.preferences.enableManufacturer
                : false;
            }
            sessionStorage.setItem("userLogin", JSON.stringify(userObj));
            this.$store.dispatch("auth/loginUser", userObj);
            this.$router.push("/dashboard");
          }
        } catch (error) {
          this.$toasted.error(error.message.message);
          this.loading = false;
        }
      } else {
        this.$toasted.error("please select login way");
      }
    },
  },
  computed: {
    tenantList() {
      let listdata = this.$store.getters["tenant/GetTenantLiteList"];
      listdata.map((object) => {
        object["name"] = object.company ? object.company.name : "";
      });
      return listdata;
    },
  },
  mounted() {
    sessionStorage.clear();
    this.GetTenantList();
  },
};
</script>
<style scoped>
.authentication-bg {
  background-image: url("/img/bg-pattern-light.svg");
  background-size: cover;
  background-position: center;
}
.bg-primary {
  background-color: rgb(114, 124, 245) !important;
}
.card-header:first-child {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  padding: 30px 5px !important;
}
.btn-primary {
  background: rgb(114, 124, 245) !important;
  border: none !important;
  border-radius: 2px !important;
  box-shadow: 0px 1px 5px 1px #989ff0 !important;
}
.form-control {
  height: calc(1.5em + 0.75rem + 10px) !important;
}
.card {
  border: none !important;
  box-shadow: 0px 1px 5px 1px #cdcfea !important;
}
.form-group {
  margin-bottom: 1px;
}
.card-body {
  margin: 6px !important;
}
</style>
